import Layout from '../../layout/index'

const joinRouter = {
  path: '/join',
  component: Layout,
  redirect: '/join/volunteer',
  children: [
    {
      path: 'volunteer',
      name: 'volunteer',
      component: () => import('../../views/join/volunteer')
    },
    {
      path: 'goldenyears',
      name: 'goldenYears',
      component: () => import('../../views/join/goldenyears')
    },
    {
      path: 'socialservice',
      name: 'socialService',
      component: () => import('../../views/join/socialservice')
    }
  ]
}
export default joinRouter
